import React from 'react';
import Icon from '../../../components/AppIcon';

const SocialAuthButton = ({ provider, onClick, disabled }) => {
  const providerConfig = {
    google: {
      icon: 'Mail',
      label: 'Continue with Google',
      bgColor: 'bg-card hover:bg-muted'
    }
  };

  const config = providerConfig?.[provider];

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`w-full flex items-center justify-center gap-3 px-4 py-3 md:py-3.5 ${config?.bgColor} border border-border rounded-lg transition-all text-sm md:text-base font-medium text-foreground disabled:opacity-50 disabled:cursor-not-allowed`}
    >
      <Icon name={config?.icon} size={20} color="currentColor" />
      <span>{config?.label}</span>
    </button>
  );
};

export default SocialAuthButton;